// Fungsi untuk buka modal edit
export function editBBM(bbm) {
    const modalBBM = document.getElementById('modalBBM');
    const formBBM = document.getElementById('formBBM');

    modalBBM.classList.remove('hidden');
    formBBM.reset();

    document.getElementById('bbm-id').value = bbm.id;
    document.getElementById('jenis_bbm').value = bbm.description;
    document.getElementById('harga').value = bbm.price;
    document.getElementById('bbm-active').checked = bbm.is_active == 1;
}

export function openModalBBM() {
    const modalBBM = document.getElementById("modalBBM");
    modalBBM.classList.remove("hidden");
}

export function closeModalBBM() {
    const modalBBM = document.getElementById("modalBBM");
    modalBBM.classList.add("hidden");
}

// Event listener global
document.addEventListener('DOMContentLoaded', function () {
    const formBBM = document.getElementById('formBBM');
    const modalBBM = document.getElementById('modalBBM');

    if (!formBBM || !modalBBM) return; // <-- stop kalau form/modal tidak ada

    window.tambahBBM = function () {
        formBBM.reset();
        document.getElementById('bbm-id').value = '';
        modalBBM.classList.remove('hidden');
    }

    window.editBBM = function (bbm) {
        formBBM.reset();
        modalBBM.classList.remove('hidden');
        document.getElementById('bbm-id').value = bbm.id;
        document.getElementById('jenis_bbm').value = bbm.description;
        document.getElementById('harga').value = bbm.price;
        document.getElementById('bbm-active').checked = bbm.is_active == 1;
    }

    formBBM.addEventListener('submit', function (e) {
        e.preventDefault();

        const formData = new FormData(formBBM);
        formData.set('is_active', document.getElementById('bbm-active').checked ? 1 : 0);

        fetch('/admin/bbm/store', {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('input[name=_token]').value
            },
            body: formData
        })
        .then(res => res.json())
        .then(res => {
            if(res.success){
                Swal.fire({
                    icon: 'success',
                    title: res.message || 'Data berhasil disimpan',
                    showConfirmButton: false,
                    timer: 1500,
                    willClose: () => {
                        modalBBM.classList.add('hidden');
                        location.reload();
                    }
                });
            } else {
                alert(res.message || 'Terjadi kesalahan');
                console.log(res.errors || res.error);
            }
        })
        .catch(err => {
            console.error(err);
            alert('Terjadi kesalahan server');
        });
    });

    // Event listener tombol edit
    document.querySelectorAll('.btn-edit-bbm').forEach(btn => {
        btn.addEventListener('click', function () {
            const bbm = {
                id: this.dataset.id,
                description: this.dataset.description,
                price: this.dataset.price,
                is_active: this.dataset.is_active
            };
            window.editBBM(bbm);
        });
    });

    // Toggle status aktif/nonaktif
    document.querySelectorAll('.toggle-status-bbm').forEach(toggle => {
        toggle.addEventListener('change', function () {

            const id = this.dataset.id;
            const is_active = this.checked ? 1 : 0;

            fetch(`/admin/bbm/update-status/${id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('input[name=_token]').value
                },
                body: JSON.stringify({
                    is_active: is_active
                })
            })
            .then(res => res.json())
            .then(res => {
                if (!res.success) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal update status'
                    });
                }
            })
            .catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Terjadi kesalahan server'
                });
            });
        });
    });

});
